import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function CorporateActionsCapsuleHelp() {
    return (
        <IconTooltip>
            <div>
                The events capsule displays the historical and upcoming
                corporate actions and holidays for the selected symbol.
                <br /> <br />
                Hover over each event and click to flip the capsule and view
                additional details.
            </div>
        </IconTooltip>
    );
}
